import Collapse from 'bee-collapse'

export default Collapse
